import React, { FC } from 'react';
import debounce from 'lodash.debounce';
import { IconCont, SimpleSearchInputComp, SimpleSearchInputCont } from './SearchSimpleInput.styles';
import SearchIcon from '@/assets/icons/searchIcon.svg?react';

interface ISearchSimpleInput {
  doSearch: (phrase: string) => void;
  placeholder?: string;
}

const SearchSimpleInput: FC<ISearchSimpleInput> = ({ doSearch, placeholder }) => {
  const search = debounce(({ target }: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = target;
    if (value && doSearch) {
      return doSearch(value);
    }
    return doSearch('');
  }, 250);
  return (
    <SimpleSearchInputCont>
      <IconCont>
        <SearchIcon />
      </IconCont>
      <SimpleSearchInputComp
        data-testid="SimpleSearchInputComp"
        placeholder={placeholder}
        onChange={search}
      />
    </SimpleSearchInputCont>
  );
};

export default SearchSimpleInput;
